(function () {
  var THREE_URL = 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.min.js';
  var loadingPromise;

  function loadThree() {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (loadingPromise) return loadingPromise;

    loadingPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = THREE_URL;
      script.async = true;
      script.onload = function () {
        if (window.THREE) resolve(window.THREE);
        else reject(new Error('3D library unavailable'));
      };
      script.onerror = function () {
        reject(new Error('3D library failed to load'));
      };
      document.head.appendChild(script);
    });

    return loadingPromise;
  }

  function createMetalMaterial(THREE, color, roughness, metalness) {
    return new THREE.MeshStandardMaterial({
      color: color,
      metalness: metalness,
      roughness: roughness,
      envMapIntensity: 1.1
    });
  }

  function addCabochon(THREE, scene, x, y, z, scaleX, scaleY, scaleZ, material) {
    var gem = new THREE.Mesh(new THREE.SphereGeometry(1, 48, 24), material);
    gem.position.set(x, y, z);
    gem.scale.set(scaleX, scaleY, scaleZ);
    scene.add(gem);
    return gem;
  }

  function buildRing(THREE, scene) {
    var gold = createMetalMaterial(THREE, 0xe0b64f, 0.14, 1);
    var warmGold = createMetalMaterial(THREE, 0xffd36b, 0.18, 1);
    var darkStone = new THREE.MeshPhysicalMaterial({
      color: 0x020202,
      metalness: 0.02,
      roughness: 0.1,
      clearcoat: 1,
      clearcoatRoughness: 0.025
    });

    var band = new THREE.Mesh(new THREE.TorusGeometry(1.58, 0.075, 28, 180), gold);
    band.scale.set(0.92, 1.06, 1);
    scene.add(band);

    var outerLine = new THREE.Mesh(new THREE.TorusGeometry(1.69, 0.018, 12, 180), warmGold);
    outerLine.scale.set(0.92, 1.06, 1);
    scene.add(outerLine);

    var innerLine = new THREE.Mesh(new THREE.TorusGeometry(1.45, 0.014, 12, 180), warmGold);
    innerLine.scale.set(0.92, 1.06, 1);
    scene.add(innerLine);

    function addShoulder(side, offset) {
      var curve = new THREE.CubicBezierCurve3(
        new THREE.Vector3(side * 1.05, 1.05, offset),
        new THREE.Vector3(side * 0.82, 1.34, 0.05 + offset),
        new THREE.Vector3(side * 0.42, 1.6, 0.12 + offset),
        new THREE.Vector3(side * 0.14, 1.78, 0.14 + offset)
      );
      var shoulder = new THREE.Mesh(new THREE.TubeGeometry(curve, 46, 0.047, 16, false), gold);
      scene.add(shoulder);
    }

    for (var side = -1; side <= 1; side += 2) {
      addShoulder(side, 0);
      addShoulder(side, -0.085);
    }

    var mainBezel = new THREE.Mesh(new THREE.TorusGeometry(0.42, 0.045, 24, 96), gold);
    mainBezel.position.set(0, 1.77, 0.12);
    mainBezel.scale.set(1.16, 0.82, 1);
    scene.add(mainBezel);

    addCabochon(THREE, scene, 0, 1.78, 0.18, 0.47, 0.35, 0.2, darkStone);

    for (var side = -1; side <= 1; side += 2) {
      var sideBezel = new THREE.Mesh(new THREE.TorusGeometry(0.22, 0.035, 18, 72), gold);
      sideBezel.position.set(side * 0.55, 1.58, 0.11);
      sideBezel.scale.set(1.04, 0.82, 1);
      sideBezel.rotation.z = side * 0.14;
      scene.add(sideBezel);

      addCabochon(THREE, scene, side * 0.55, 1.59, 0.16, 0.21, 0.17, 0.1, darkStone);

      var lowerCup = new THREE.Mesh(new THREE.TorusGeometry(0.17, 0.026, 16, 56), warmGold);
      lowerCup.position.set(side * 0.42, 1.43, 0.06);
      lowerCup.scale.set(1.18, 0.64, 1);
      lowerCup.rotation.z = side * 0.28;
      scene.add(lowerCup);
    }

    for (var i = 0; i < 6; i += 1) {
      var prongAngle = (i / 6) * Math.PI * 2;
      var prong = new THREE.Mesh(new THREE.SphereGeometry(0.038, 14, 14), warmGold);
      prong.position.set(Math.cos(prongAngle) * 0.43, 1.78 + Math.sin(prongAngle) * 0.31, 0.31);
      prong.scale.set(1, 1, 0.72);
      scene.add(prong);
    }
  }

  function initViewer(root) {
    if (!root || root.dataset.ownart3dReady === 'true') return;

    var canvas = root.querySelector('[data-ownart-product-3d-canvas]');
    if (!canvas) return;

    root.dataset.ownart3dReady = 'true';

    loadThree().then(function (THREE) {
      var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputColorSpace = THREE.SRGBColorSpace;

      var scene = new THREE.Scene();
      scene.background = new THREE.Color(0xf5f4f2);

      var camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
      camera.position.set(0, 0.22, 7.4);

      scene.add(new THREE.AmbientLight(0xffffff, 1.6));
      var key = new THREE.DirectionalLight(0xffffff, 2.4);
      key.position.set(3, 5, 4);
      scene.add(key);
      var rim = new THREE.DirectionalLight(0xfff2d1, 1.2);
      rim.position.set(-4, 2, -2);
      scene.add(rim);

      var group = new THREE.Group();
      scene.add(group);
      buildRing(THREE, group);
      group.rotation.x = -0.04;
      group.rotation.y = 0.02;
      group.rotation.z = -0.03;
      group.scale.set(0.84, 0.84, 0.84);

      var shadow = new THREE.Mesh(
        new THREE.CircleGeometry(1.65, 80),
        new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.08 })
      );
      shadow.rotation.x = -Math.PI / 2;
      shadow.position.y = -1.95;
      shadow.scale.set(1.6, 0.34, 1);
      scene.add(shadow);

      var dragging = false;
      var lastX = 0;
      var lastY = 0;
      var targetRotationY = group.rotation.y;
      var targetRotationX = group.rotation.x;

      function resize() {
        var rect = canvas.getBoundingClientRect();
        renderer.setSize(rect.width, rect.height, false);
        camera.aspect = rect.width / Math.max(rect.height, 1);
        camera.updateProjectionMatrix();
      }

      function pointerDown(event) {
        dragging = true;
        lastX = event.clientX;
        lastY = event.clientY;
        canvas.setPointerCapture(event.pointerId);
      }

      function pointerMove(event) {
        if (!dragging) return;
        var dx = event.clientX - lastX;
        var dy = event.clientY - lastY;
        targetRotationY += dx * 0.012;
        targetRotationX += dy * 0.008;
        targetRotationX = Math.max(-1.0, Math.min(0.7, targetRotationX));
        lastX = event.clientX;
        lastY = event.clientY;
      }

      function pointerUp(event) {
        dragging = false;
        if (canvas.hasPointerCapture(event.pointerId)) {
          canvas.releasePointerCapture(event.pointerId);
        }
      }

      function wheel(event) {
        event.preventDefault();
        camera.position.z = Math.max(3.8, Math.min(8, camera.position.z + event.deltaY * 0.004));
      }

      canvas.addEventListener('pointerdown', pointerDown);
      canvas.addEventListener('pointermove', pointerMove);
      canvas.addEventListener('pointerup', pointerUp);
      canvas.addEventListener('pointercancel', pointerUp);
      canvas.addEventListener('wheel', wheel, { passive: false });

      function render() {
        if (!dragging) targetRotationY += 0.0012;
        group.rotation.y += (targetRotationY - group.rotation.y) * 0.12;
        group.rotation.x += (targetRotationX - group.rotation.x) * 0.12;
        renderer.render(scene, camera);
        window.requestAnimationFrame(render);
      }

      resize();
      window.addEventListener('resize', resize);
      root.classList.add('is-ready');
      render();
    }).catch(function () {
      var loading = root.querySelector('[data-ownart-product-3d-loading]');
      if (loading) loading.textContent = '3D preview is unavailable. Please try again later.';
    });
  }

  function openViewer(root) {
    if (!root) return;
    root.hidden = false;
    document.body.classList.add('ownart-product-3d-open');
    initViewer(root);
  }

  function closeViewer(root) {
    if (!root) return;
    root.hidden = true;
    document.body.classList.remove('ownart-product-3d-open');
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-ownart-product-3d-open]');
    if (open) {
      openViewer(document.querySelector('[data-ownart-product-3d]'));
      return;
    }

    var close = event.target.closest('[data-ownart-product-3d-close]');
    if (close) {
      closeViewer(close.closest('[data-ownart-product-3d]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeViewer(document.querySelector('[data-ownart-product-3d]:not([hidden])'));
    }
  });
})();
